<template>
  <div v-if="productPageStore.productState.selectedDownPaymentTime !== '1'">
    <AppLoanWarningBox />
  </div>
</template>

<script lang="ts" setup>
const productPageStore = useMyProductPageStore();
</script>
